class ABRVue {

	static install (Vue, options) {

		Vue.directive('icon', function (value) {
			this.el.setAttribute('src', window.Drupal.settings.abr_general.theme_path + '/img/icons/' + value);
		});

		Vue.transition('motion-ui', {
			css: false,
			enter: function (el, done) {
				var animation = window.jQuery(el).attr('data-in');
				if (animation && typeof(window.MotionUI.animateIn) !== 'undefined') {
					window.MotionUI.animateIn(window.jQuery(el), animation, done);
				} else {
					window.jQuery(el).hide();
					setTimeout(done, 0);
				}
			},
			leave: function (el, done) {
				var animation = window.jQuery(el).attr('data-out');
				if (animation && typeof(window.MotionUI.animateOut) !== 'undefined') {
					window.MotionUI.animateOut(window.jQuery(el), animation, done);
				} else {
					window.jQuery(el).hide();
					setTimeout(done, 0);
				}
			}
		});

	}

}

export default ABRVue;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/common/ABRVue.js
 **/